import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { ReservationsByLocationAndNetworkServices } from "../../../../services";
import {
  FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT,
  FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST,
  EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK,
  TOAST,
  SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
  CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
} from "../../../types/Reservations/ReservationsByLocationAndNetwork.type";

export const initializeReservationsByLocationAndNetworkScreen = () => ({
  type: FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT,
});

export const fetchReservationsByLocationAndNetworkStart = (payload) => ({
  type: FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.START,
  payload,
});

export const fetchReservationsByLocationAndNetworkSuccess = (payload) => ({
  type: FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.SUCCESS,
  payload,
});

export const fetchReservationsByLocationAndNetworkError = (payload) => ({
  type: FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.ERROR,
  payload,
});

export const fetchReservationsByLocationAndNetwork = (payload) => {
  return (dispatch) => {
    dispatch(fetchReservationsByLocationAndNetworkStart(payload));
    ReservationsByLocationAndNetworkServices.fetchReservationsByLocationAndNetwork(payload).then(
      (data) => {
        if (!data.isError) {
          dispatch(fetchReservationsByLocationAndNetworkSuccess(data));
        } else {
          dispatch(fetchReservationsByLocationAndNetworkError(data));
        }
      }
    );
  };
};

export const exportReservationsByLocationAndNetwork = (payload) => {
  return (dispatch) => {
    dispatch({ type: EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.START });
    ReservationsByLocationAndNetworkServices.exportReservationsByLocationAndNetworkRecord(payload).then(
      (data) => {
        if (!data.isError) {
          dispatch({
            type: EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.SUCCESS,
            payload: data,
          });
        } else {
          dispatch({
            type: EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.ERROR,
            payload: data,
          });
        }
        setTimeout(() => {
          dispatch(resetToast());
        }, DEFAULT_TOAST_LIFE + 1000);
      }
    );
  };
};

export const resetToast = () => ({
  type: TOAST.RESET,
});

export const setReservationsByLocationAndNetworkFilters = (filters) => ({
  type: SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
  payload: filters,
});

export const clearReservationsByLocationAndNetworkFilters = () => ({
  type: CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
});
